<template>
  <span v-if="linkedinUrl || salesforceUrl || hubspotUrl || pipedriveUrl || leadiqEnriched" class="integrationBadges">
    <a
      v-if="linkedinUrl"
      :href="linkedinUrl"
      target="_blank"
      rel="noopener"
      class="integrationFaviconLink"
      title="Open LinkedIn page"
      @click.stop
    >
      <FavIcon domain="linkedin.com" :size="size" />
    </a>
    <a
      v-if="salesforceUrl"
      :href="salesforceUrl"
      target="_blank"
      rel="noopener"
      class="integrationFaviconLink"
      title="Open in Salesforce"
      @click.stop
    >
      <AppIcon name="salesforce" :size="size" />
    </a>
    <a
      v-if="hubspotUrl"
      :href="hubspotUrl"
      target="_blank"
      rel="noopener"
      class="integrationFaviconLink"
      title="Open in HubSpot"
      @click.stop
    >
      <AppIcon name="hubspot" :size="size" />
    </a>
    <a
      v-if="pipedriveUrl"
      :href="pipedriveUrl"
      target="_blank"
      rel="noopener"
      class="integrationFaviconLink"
      title="Open in Pipedrive"
      @click.stop
    >
      <AppIcon name="pipedrive" :size="size" />
    </a>
    <span v-if="leadiqEnriched" title="Enriched by LeadIQ">
      <AppIcon name="leadiq" :size="size" />
    </span>
  </span>
</template>

<script setup lang="ts">
import AppIcon from './AppIcon.vue'
import FavIcon from './FavIcon.vue'

withDefaults(defineProps<{
  linkedinUrl?: string | null
  salesforceUrl?: string | null
  hubspotUrl?: string | null
  pipedriveUrl?: string | null
  leadiqEnriched?: boolean
  size?: number
}>(), {
  size: 14,
})
</script>

<style scoped>
.integrationBadges {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
}

.integrationFaviconLink {
  display: flex;
  align-items: center;
  line-height: 0;
}
</style>
